import React from 'react'
import PropTypes from 'prop-types'

import InternalLink from '../../../../../components/InternalLink'
import Goal from './Goal'

import { TIKTOK_PROVIDER_PLATFORM } from '../../../../../constants/selectLists/platformList'
import { formatDateShort } from '../../../../../constants/dates'

import useStyles from '../../styles'

const NameCell = ({ item, getShowGoal, listItemType, createItemLinkHelper, createItemLinkExtraParams }) => {
  const classes = useStyles()

  const { name, date_start: dateStart, date_stop: dateStop, provider } = item

  const summaryPageLink = createItemLinkHelper && createItemLinkHelper(item, createItemLinkExtraParams)

  return (
    <>
      {summaryPageLink ? (
        <InternalLink to={summaryPageLink} className={classes.nameLink}>
          {name}
        </InternalLink>
      ) : (
        name
      )}
      {dateStart && (
        <div className={classes.columnSubText}>
          {provider === TIKTOK_PROVIDER_PLATFORM ? (
            // render only start date for tiktok
            <>{formatDateShort(dateStart)}</>
          ) : (
            <>
              {formatDateShort(dateStart)}
              {' - '}
              {dateStop ? formatDateShort(dateStop) : 'Ongoing'}
            </>
          )}
        </div>
      )}
      <Goal item={item} getShowGoal={getShowGoal} listItemType={listItemType} />
    </>
  )
}

NameCell.propTypes = {
  item: PropTypes.object.isRequired,
  createItemLinkHelper: PropTypes.func,
  createItemLinkExtraParams: PropTypes.object,
  getShowGoal: PropTypes.func,
  listItemType: PropTypes.string
}

export default NameCell
